<!-- Content Area -->
<div class="p-8">
    <div class="flex justify-between items-center mb-6">
        <h1 class="text-xl lg:text-3xl font-bold text-gray-900">Payment Gateway List</h1>
        <button
            (click)="openaddModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 text-base lg:text-sm font-semibold rounded-lg transition flex items-center gap-2"
        >
            <span>+</span>
            <span>Add Payment Gateway</span>
        </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6">
        <div class="overflow-x-auto">
            <table class="w-full">
                <thead>
                    <tr class="border-b border-gray-200">
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            No
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            ID
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Name
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Code
                        </th>
                        <th
                            class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Status
                        </th>
                        <th
                            class="text-center py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider"
                        >
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr
                        *ngFor="let item of paymentGateway; let i = index"
                        class="hover:bg-gray-50 transition-colors"
                    >
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ (pagination.current_page - 1) * pagination.per_page + i + 1 }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ item.id }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ item.name }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ item.code }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ item.status }}
                        </td>
                        <td class="py-4 px-6">
                            <div class="flex items-center justify-center gap-0">
                                <button
                                    (click)="openeditModal(item.id)"
                                    class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-3 rounded-l-lg hover:bg-gray-50 flex items-center gap-1 whitespace-nowrap"
                                >
                                    <img
                                        src="assets/visidea/icon/pencil-write.png"
                                        class="w-4 h-4 flex-shrink-0"
                                        alt="Edit"
                                    />
                                </button>
                                <button
                                    (click)="deleteData(item.id)"
                                    class="text-red-500 hover:text-red-700 transition-colors border border-[#D5D5D5] py-2 px-3 rounded-r-lg hover:bg-red-50 flex items-center gap-1 whitespace-nowrap"
                                >
                                    <img
                                        src="assets/visidea/icon/bin.png"
                                        class="w-4 h-4 flex-shrink-0"
                                        alt="Delete"
                                    />
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="paymentGateway.length === 0">
                        <td colspan="6" class="py-8 text-center text-gray-500">
                            Tidak ada data payment gateway
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div
            class="flex items-center justify-between px-6 py-4 border-t border-gray-200"
        >
            <button
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <img
                    src="assets/visidea/icon/left.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
                <span>Previous</span>
            </button>

            <span class="text-sm text-gray-600">
                Page {{ pagination.current_page }} of {{ pagination.total_page }}
            </span>

            <button
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <span>Next</span>
                <img
                    src="assets/visidea/icon/right.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
            </button>
        </div>
    </div>
</div>

<div
    *ngIf="isModalOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    (click)="closeModal()"
>
    <div
        class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn"
        (click)="$event.stopPropagation()"
    >
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                {{ isEditMode ? "Edit Payment Gateway" : "Add New Payment Gateway" }}
            </h2>
            <button
                (click)="closeModal()"
                class="text-gray-400 hover:text-gray-600 text-2xl"
            >
                &times;
            </button>
        </div>

        <form (ngSubmit)="onSubmit()" #categoryFormElement="ngForm">
            <!-- Name -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Name <span class="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    [(ngModel)]="createDataForm.name"
                    name="name"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter payment gateway name"
                />
            </div>

            <!-- Code -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Code <span class="text-red-500">*</span>
                </label>
                <textarea
                    [(ngModel)]="createDataForm.code"
                    name="code"
                    required
                    rows="3"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter payment gateway code"
                ></textarea>
            </div>

            <!-- Status -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Status <span class="text-red-500">*</span>
                </label>
                <select
                    [(ngModel)]="createDataForm.status"
                    name="status"
                    required
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <option value="inactive">Inactive</option>
                    <option value="active">Active</option>
                </select>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button
                    type="button"
                    (click)="closeModal()"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="submit"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? "Update" : "Create" }}
                    </span>
                    <span *ngIf="isSubmitting">Processing...</span>
                </button>
            </div>
        </form>
    </div>
</div>
